import React, {useEffect, useRef} from 'react'
import ButterflyImg from './_assets/butterfly.webp'
import Pearl_1 from '../Pearl/_assets/pearl_1.webp'
import Pearl from '../Pearl/Pearl'
import type {ColorClassKey} from './types'

import Styles from './Wing.module.css'

interface WingProps {
  pearlTrigger: boolean
  wingRef: React.RefObject<HTMLDivElement | null>
  DefaultColorClass: ColorClassKey
}

const Wing: React.FC<WingProps> = ({pearlTrigger, wingRef, DefaultColorClass}) => {
  const defaultWingRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
    const wing = wingRef.current

    if (wing) {
      if (mediaQuery.matches) {
        if (Styles.NoAnimation) wing.classList.add(Styles.NoAnimation)
      } else {
        if (Styles.AfterAnimation) {
          if (pearlTrigger) {
            wing.classList.remove(Styles.AfterAnimation)
          } else {
            wing.classList.add(Styles.AfterAnimation)
          }
        }
      }
    }
  }, [pearlTrigger, wingRef])

  return (
    <div className={Styles.Wing} ref={wingRef}>
      <div className={Styles.WingMask} style={{maskImage: `url(${ButterflyImg})`}}>
        <Pearl pearlTrigger={pearlTrigger} />
        <div
          className={`${Styles.DefaultColor} ${DefaultColorClass ? Styles[DefaultColorClass] : ''}`}
          ref={defaultWingRef}
        />
      </div>
      <div className={Styles.WingBlur}>
        <div
          className={Styles.WingBlurMaskPearl}
          style={{maskImage: `url(${ButterflyImg})`, backgroundImage: `url(${Pearl_1})`}}
        />
        {DefaultColorClass === 'DefaultWhiteColor' && (
          <div className={Styles.WingBlurMask} style={{maskImage: `url(${ButterflyImg})`}} />
        )}
      </div>
    </div>
  )
}

export default Wing

try{ Wing.displayName ||= 'Wing' } catch {}